export default function Banner({ type = "success", message }) {
  if (!message) return null;

  const baseClasses =
    "fixed top-0 left-0 w-full px-4 py-2 shadow-md z-50 text-center";
  const styles = {
    success: "bg-green-100 text-green-700",
    error: "bg-red-100 text-red-600",
    warning: "bg-yellow-100 text-yellow-700",
    info: "bg-blue-100 text-blue-700",
  };

  return (
    <div className={`${baseClasses} ${styles[type] || styles.info}`}
      data-aos="fade-down"
    >
      {message}
    </div>
  );
}
